import { render } from "./SkinProfileForm.vue?vue&type=template&id=34e62cea&scoped=true&bindings={}"
import script from "./SkinProfileForm.vue?vue&type=script&lang=ts"
export * from "./SkinProfileForm.vue?vue&type=script&lang=ts"

import "./SkinProfileForm.vue?vue&type=style&index=0&id=34e62cea&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-34e62cea"

export default script